module.exports = __webpack_public_path__ + "img/bonus.0ce82c42.jpg";